<script>
import classes from '~~/common/vue/mixins/classes';

// TODO: refactor and rename to `variant`
export const colors = ['primary', 'secondary', 'dark', 'bare', 'result'];

export default {
  name: 'ELink',
  mixins: [classes],
  props: {
    as: {
      type: String,
      default: 'a',
      cssClass: true,
    },
    // TODO: refactor and rename to `variant`
    color: {
      type: String,
      default: colors[0],
      cssClass: true,
      validator: (value) => colors.includes(value),
    },
  },
  render(create) {
    const attrs = {};
    if (this.as !== 'a') {
      attrs.role = 'button';
    }
    const options = {
      class: this.classes,
      attrs: { ...attrs, ...this.$attrs },
      on: this.$listeners,
    };
    return create(this.as, options, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped>
$colors: (
  "primary": var(--color-link-primary),
  "secondary": var(--color-link-secondary),
  "white": var(--color-text-tertiary),
  "dark": var(--color-text-primary),
  "result": var(--color-link-results-default),
);

.link {
  text-decoration: none;
  transition: color $timing-2s $easing;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}

@each $name, $color in $colors {
  .link--color-#{$name} {
    color: $color;
  }
}

// TODO: this is the only link variant where we have a different
// colour for the hover state. Find out if this can be simplified,
// since it might require separate semantic tokens.
.link--color-bare {
  color: var(--color-text-secondary);

  &:hover,
  &:focus {
    color: var(--color-text-primary);
  }
}

.link--color-result {
  &:visited {
    color: var(--color-link-results-visited);
  }
}

.link--as-button {
  appearance: none;
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  font: inherit;
  text-transform: none;
}
</style>
